import { Breadcrumb } from 'antd';
import { LayoutCMS } from 'components';
import React from 'react';
import { Link } from 'react-router-dom';
import TablePost from './libraries';

export const PagePostComponent = (props: any) => {
    const title = 'Post';
    const layoutCMSProps = {
        breadcrumb: (
            <>
                <Breadcrumb.Item>
                    <Link to="/article/posts">{title}</Link>
                </Breadcrumb.Item>
            </>
        ),
        documentTitle: title,
        history: props.history,
        pageTitle: title,
    };
    return (
        <LayoutCMS {...layoutCMSProps}>
            <TablePost />
        </LayoutCMS>
    );
};

export default PagePostComponent;



// WEBPACK FOOTER //
// ./src/pages/post/component.tsx